// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1ijB5","label":"Radio_label__20zSD","checkMark":"Radio_checkMark__3GYox","disabled":"Radio_disabled__1BWAn"};